module.exports = __webpack_public_path__ + "img/slide12.7f70e3b0.png";